export default function formatRelatesMapping(relatesList) {
  let relateMapping = {};

  relatesList.forEach((relate) => {
    relateMapping[relate.field] = relate.value.id ?? relate.value;
  })

  return relateMapping;
}